<p-card styleClass="login-card">
  @if (isLoading || isRedirecting) {
    <div class="login-overlay" role="status" aria-live="polite">
      <p-progressSpinner strokeWidth="4" ariaLabel="Cargando" />
      <p class="login-overlay__message mb-0">
        {{ redirectMessage || 'Iniciando sesión...' }}
      </p>
    </div>
  }

  <h3>Acceso de clientes</h3>
  <p class="login-subtitle text-secondary mb-4">Introduce tus credenciales para acceder a tu portal</p>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <p-floatlabel variant="in">
      <p-iconfield>
        <p-inputicon class="pi pi-user" />
        <input
          pInputText
          id="username"
          class="w-100"
          formControlName="username"
          autocomplete="username"
          autofocus
        />
      </p-iconfield>
      <label for="username">Usuario o Email</label>
    </p-floatlabel>

    <p-floatlabel class="my-3 password-field" variant="in">
      <p-iconfield>
        <p-inputicon class="pi pi-lock" />
        <input
          pInputText
          [type]="showPassword ? 'text' : 'password'"
          id="password"
          class="w-100"
          formControlName="password"
          autocomplete="current-password"
        />
        <p-inputicon
          class="pi pointer password-toggle"
          [class.pi-eye]="!showPassword"
          [class.pi-eye-slash]="showPassword"
          (click)="togglePasswordVisibility()"
          role="button"
          tabindex="0"
          aria-label="Mostrar u ocultar contraseña"
          (keydown.enter)="togglePasswordVisibility()"
          (keydown.space)="togglePasswordVisibility(); $event.preventDefault()"
        />
      </p-iconfield>
      <label for="password">Contraseña</label>
    </p-floatlabel>

    <div class="d-flex">
      <a class="pointer ms-auto mb-3" routerLink="/recovery">¿Has olvidado tu contraseña?</a>
    </div>

    <p-button
      type="submit"
      [label]="isLoading ? 'Iniciando sesión...' : 'Acceder'"
      class="w-100"
      [style]="{ width: '100%' }"
      [disabled]="isLoading || isRedirecting"
      [loading]="isLoading && !isRedirecting"
    />

    @if (loginError) {
      <p-message styleClass="mt-3" severity="error">{{ loginError }}</p-message>
    }

    <div class="mt-4 w-100 d-flex">
      <img class="img-fluid px-5 mx-auto" [src]="brandProfile.logoPath" [alt]="brandProfile.companyName" />
    </div>

    <p class="legal-links small text-center mt-3 mb-0">
      <a [href]="legalNoticeUrl" target="_blank" rel="noopener noreferrer">Aviso legal</a>
      <span class="mx-2">·</span>
      <a [href]="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Política de privacidad</a>
    </p>
  </form>
</p-card>
